module.exports = __webpack_public_path__ + "media/1_17.713769b0.wav";